import React, { useState } from "react";
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const RequiredFieldsForm = ({ formData, onChange, errors }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 500 }}>
          Required Information
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="First Name"
          value={formData.firstName}
          onChange={(e) => onChange("firstName", e.target.value)}
          fullWidth
          error={Boolean(errors.firstName)}
          helperText={errors.firstName}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Last Name"
          value={formData.lastName}
          onChange={(e) => onChange("lastName", e.target.value)}
          fullWidth
          error={Boolean(errors.lastName)}
          helperText={errors.lastName}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          type="email"
          label="Email"
          value={formData.email}
          onChange={(e) => onChange("email", e.target.value)}
          fullWidth
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          type={showPassword ? "text" : "password"}
          label="Password"
          value={formData.password}
          onChange={(e) => onChange("password", e.target.value)}
          fullWidth
          error={Boolean(errors.password)}
          helperText={errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </>
  );
};

export default RequiredFieldsForm;
